export const Constants = {
    CAM_DATE_SPAN_MS : 86400000, // in miliseconds
    SMART_CAM_ID: '86ebde6b-7a6e-47a3-b3e1-2336e6255370',
    POLL_INTERVAL:10000,
}